import { SubmissionError } from '#helper/submission-error';
import {
  FETCH_SHIPMENT_PROJECTS,
  FETCH_SHIPMENT,
  FETCH_SHIPMENTS_STARTED,
  FETCH_SHIPMENTS_SUCCEEDED,
  FETCH_SHIPMENTS_FAILED,
  CLEAR_SHIPMENTS,
  FETCH_SHIPMENT_DATE,
  ERROR
} from '#action/types';
import { fetchAdditions, snackBarError } from '#action/fetch';
import { fetchProjectCustomFields } from '#action/project/custom-fields';
import { webPortalApi } from '#config/web-portal-api';
import { shipmentEventType } from '#type';
import { getRequestOptions } from '#helper';
import { history } from '#configureStore';

let abortController = new AbortController();

export const fetchShipmentProjects = projectId =>
  dispatch =>
    dispatch(fetchAdditions(`project?modules=true&ids=${projectId}`, FETCH_SHIPMENT_PROJECTS));

export const createShipment = data =>
  async dispatch => {
    const res1 = await fetch(webPortalApi.buildApiUrl('shipment?source=ui'), {
      method: 'POST',
      body: JSON.stringify(data),
      ...getRequestOptions()
    });
    const response1 = await res1.json();
    if (!res1.ok) {
      dispatch(
        snackBarError({
          message: 'Error in request',
          ...response1
        })
      );
      throw new SubmissionError(response1);
    }

    return { id: response1.id, success: true };
  };

export const fetchShipment = (id, withCustomFields) => async dispatch => {
  const response = await dispatch(fetchAdditions(`shipment/${id}`, FETCH_SHIPMENT));
  const shallRedirect = response.type === ERROR;

  if (shallRedirect) {
    await history.push('/shipment');

    return;
  }

  const requests = [];

  if (response.payload?.projectId) {
    requests.push(dispatch(fetchShipmentProjects(response.payload?.projectId)));
  }

  if (withCustomFields && response.payload?.projectId) {
    requests.push(dispatch(fetchProjectCustomFields(response.payload.projectId)));
  }

  await Promise.all(requests);
};

export const editShipment = (id, data) =>
  async dispatch => {
    const { label, customFields } = data;
    const res1 = await fetch(webPortalApi.buildApiUrl(`shipment/${id}`), {
      method: 'PATCH',
      body: JSON.stringify({
        label,
        customFields
      }),
      ...getRequestOptions()
    });
    const response1 = await res1.json();
    if (!res1.ok) {
      dispatch(
        snackBarError({
          message: 'Error in request',
          ...response1
        })
      );
      throw new SubmissionError(response1);
    }

    return { success: true };
  };

export const fetchShipments = dateRange => async dispatch => {
  try {
    abortController.abort();
    let url = webPortalApi.buildApiUrl('shipment/details?&order=desc&orderBy=startDate');

    if (dateRange) {
      const { start, end } = dateRange;
      url += `&start=${start}&end=${end}`;
    }

    dispatch({
      type: FETCH_SHIPMENTS_STARTED
    });
    abortController = new AbortController();
    const { signal } = abortController;
    const res = await fetch(url, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }
    const shipments = await res.json();

    if (shipments.length > 0) {
      const shipmentIds = shipments.map(shipment => shipment.id).join(',');

      const logsURL = webPortalApi.buildApiUrl('shipment/log');
      const logsParams = new URLSearchParams({
        shipment: shipmentIds, event: shipmentEventType.TRIGGER_ALERT
      });

      const logsRes = await fetch(`${logsURL}?${shipmentIds.length > 0 && logsParams.toString()}`, getRequestOptions());
      const { logs = [] } = await logsRes.json();

      return dispatch({
        type: FETCH_SHIPMENTS_SUCCEEDED,
        payload: {
          shipments,
          logs
        }
      });
    }

    return dispatch({
      type: FETCH_SHIPMENTS_SUCCEEDED,
      payload: shipments
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return false;
    }
    return dispatch({
      type: FETCH_SHIPMENTS_FAILED,
      error: e
    });
  }
};

export const fetchShipmentDate = () =>
  dispatch =>
    dispatch({ type: FETCH_SHIPMENT_DATE });

export const clearShipments = () =>
  dispatch =>
    dispatch({ type: CLEAR_SHIPMENTS });
